(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        if (e.target.__mtOnVisible) e.target.__mtOnVisible();
        observer.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
    return observer;
  }

  function initReveals(root) {
    var els = root.querySelectorAll('.mt-reveal, [data-mt-observar]');
    var obs = getObserver();
    els.forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!obs || reduce) { el.classList.add('mt-visible'); if (el.__mtOnVisible) el.__mtOnVisible(); return; }
      obs.observe(el);
    });
  }

  /* Héroe: el producto se inclina siguiendo al cursor (arquetipo 5) */
  function initTilt(root) {
    root.querySelectorAll('[data-mt-tilt]').forEach(function (escena) {
      if (escena.dataset.mtInit) return;
      escena.dataset.mtInit = '1';
      var prod = escena.querySelector('.mt-hero__producto');
      var max = parseFloat(escena.dataset.mtTilt) || 8;
      if (!prod || reduce || window.matchMedia('(hover: none)').matches) return;
      var zona = escena.closest('.mt-hero') || escena;
      zona.addEventListener('mousemove', function (ev) {
        var r = escena.getBoundingClientRect();
        var x = (ev.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var y = (ev.clientY - (r.top + r.height / 2)) / (r.height / 2);
        x = Math.max(-1, Math.min(1, x)); y = Math.max(-1, Math.min(1, y));
        prod.style.transform = 'rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg)';
      });
      zona.addEventListener('mouseleave', function () { prod.style.transform = ''; });
    });
  }

  /* Botón magnético (arquetipo 88) */
  function initMagnetico(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('[data-mt-magnetico]').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) / r.width;
        var y = (ev.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 10) + 'px,' + (y * 8) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* Hotspots (arquetipo 17) */
  function initHotspots(root) {
    root.querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs__punto');
      var items = sec.querySelectorAll('.mt-hs__item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('mt-activo', j === i); p.setAttribute('aria-pressed', j === i); });
        items.forEach(function (it, j) { it.classList.toggle('mt-activo', j === i); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { activar(i); if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        p.addEventListener('mouseenter', function () { activar(i); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activar(i); });
        it.addEventListener('click', function () { activar(i); });
      });
      if (puntos.length) activar(0);
    });
  }

  /* Rutina: aro de progreso + contador (arquetipo 54) */
  function initRutina(root) {
    root.querySelectorAll('[data-mt-rutina]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var cifra = el.querySelector('.mt-rut__cifra');
      var final = parseInt(el.dataset.mtRutina, 10) || 0;
      el.__mtOnVisible = function () {
        if (!cifra || reduce) return;
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          cifra.textContent = Math.round(final * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(paso);
        }
        cifra.textContent = '0';
        requestAnimationFrame(paso);
      };
    });
  }

  /* Antes / después con deslizador (arquetipo 36) */
  function initAntesDespues(root) {
    root.querySelectorAll('[data-mt-antes-despues]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var control = el.querySelector('.mt-ad__control');
      if (!control) return;
      function poner(v) { el.style.setProperty('--pos', v + '%'); }
      control.addEventListener('input', function () { el.classList.remove('mt-ad--pista'); poner(control.value); });
      var inicio = parseFloat(control.value) || 50;
      el.__mtOnVisible = function () {
        if (reduce) return;
        // pista: la barra se mueve sola un momento para que se entienda que es deslizable
        el.classList.add('mt-ad--pista');
        setTimeout(function () { poner(Math.max(inicio - 22, 8)); }, 400);
        setTimeout(function () { poner(Math.min(inicio + 22, 92)); }, 1400);
        setTimeout(function () { poner(inicio); }, 2400);
        setTimeout(function () { el.classList.remove('mt-ad--pista'); }, 3400);
      };
    });
  }

  /* Héroe carrusel: escenas que cambian solas, pestañas con progreso y deslizamiento en móvil */
  function initCarrusel(root) {
    root.querySelectorAll('[data-mt-carrusel]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var slides = sec.querySelectorAll('[data-mt-hc-slide]');
      var textos = sec.querySelectorAll('[data-mt-hc-texto]');
      var tabs = sec.querySelectorAll('[data-mt-hc-tab]');
      var total = slides.length;
      if (total < 2) return;
      var actual = 0, timer = null, pausa = false;
      var auto = sec.dataset.autoplay === 'true' && !reduce;
      var ms = (parseFloat(sec.dataset.intervalo) || 6) * 1000;
      if (!auto) sec.classList.add('mt-hc--fijo');

      function ir(i) {
        actual = (i + total) % total;
        [slides, textos, tabs].forEach(function (lista) {
          lista.forEach(function (el, j) {
            el.classList.toggle('mt-activo', j === actual);
            if (el.hasAttribute('data-mt-hc-tab')) el.setAttribute('aria-selected', j === actual ? 'true' : 'false');
            if (el.hasAttribute('data-mt-hc-texto')) { if (j === actual) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true'); }
          });
        });
        // precio, botón y ventajas de la escena activa
        sec.querySelectorAll('[data-mt-hc-sync]').forEach(function (el) {
          var activo = Number(el.getAttribute('data-mt-hc-sync')) === actual;
          el.classList.toggle('mt-activo', activo);
          if (activo) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
          el.querySelectorAll('a').forEach(function (a) { if (activo) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
        // reinicia la barra de progreso de la pestaña activa
        var barra = tabs[actual] && tabs[actual].querySelector('i');
        if (barra) { barra.style.animation = 'none'; void barra.offsetWidth; barra.style.animation = ''; }
        programar();
      }
      function programar() {
        clearTimeout(timer);
        if (!auto || pausa) return;
        timer = setTimeout(function () { ir(actual + 1); }, ms);
      }
      function pausar(v) {
        pausa = v;
        sec.classList.toggle('mt-hc--pausa', v);
        if (v) clearTimeout(timer); else programar();
      }

      tabs.forEach(function (t, i) { t.addEventListener('click', function () { ir(i); }); });
      if (!window.matchMedia('(hover: none)').matches) {
        sec.addEventListener('mouseenter', function () { pausar(true); });
        sec.addEventListener('mouseleave', function () { pausar(false); });
      }
      document.addEventListener('visibilitychange', function () { pausar(document.hidden); });

      var media = sec.querySelector('[data-mt-hc-media]');
      var x0 = null, deslizo = false;
      if (media) {
        media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; deslizo = false; }, { passive: true });
        media.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          x0 = null;
          if (Math.abs(dx) > 40) { deslizo = true; ir(actual + (dx < 0 ? 1 : -1)); }
        });
        // Tocar o dar clic en la foto lleva al producto de la escena activa (si fue un deslizamiento, solo cambia de escena)
        media.addEventListener('click', function () {
          if (deslizo) { deslizo = false; return; }
          var url = slides[actual] && slides[actual].dataset.url;
          if (url) window.location.href = url;
        });
      }
      programar();
    });
  }

  /* FAQ (arquetipo 80) */
  function initFaq(root) {
    root.querySelectorAll('[data-mt-faq]').forEach(function (lista) {
      if (lista.dataset.mtInit) return;
      lista.dataset.mtInit = '1';
      var unico = lista.dataset.mtFaq === 'unico';
      lista.querySelectorAll('.mt-faq__item').forEach(function (item) {
        var btn = item.querySelector('.mt-faq__pregunta');
        btn.addEventListener('click', function () {
          var abrir = !item.classList.contains('mt-abierto');
          if (unico) lista.querySelectorAll('.mt-faq__item.mt-abierto').forEach(function (o) { o.classList.remove('mt-abierto'); o.querySelector('.mt-faq__pregunta').setAttribute('aria-expanded', 'false'); });
          item.classList.toggle('mt-abierto', abrir);
          btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* Página de producto: galería + variantes */
  function initProducto(root) {
    root.querySelectorAll('[data-mt-producto]').forEach(function (pp) {
      if (pp.dataset.mtInit) return;
      pp.dataset.mtInit = '1';
      var principal = pp.querySelector('.mt-pp__principal img');
      var video = pp.querySelector('.mt-pp__video');
      pp.querySelectorAll('.mt-pp__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          // Video: se reproduce en el lugar de la foto principal
          if (mini.dataset.video && video) {
            if (video.getAttribute('src') !== mini.dataset.video) { video.src = mini.dataset.video; video.poster = mini.dataset.src; }
            principal.hidden = true;
            video.hidden = false;
            var p = video.play(); if (p && p.catch) p.catch(function () {});
            pp.querySelectorAll('.mt-pp__mini').forEach(function (m) { m.classList.toggle('mt-activo', m === mini); });
            return;
          }
          if (video && !video.hidden) { video.pause(); video.hidden = true; principal.hidden = false; }
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = mini.dataset.src;
            principal.removeAttribute('srcset');
            principal.alt = mini.dataset.alt || '';
            principal.style.opacity = '1';
          }, 180);
          pp.querySelectorAll('.mt-pp__mini').forEach(function (m) { m.classList.remove('mt-activo'); });
          mini.classList.add('mt-activo');
        });
      });

      // Kit: el selector de color cambia el masajeador que se agregará y la foto principal
      var kitInput = pp.querySelector('[data-mt-kit-masajeador]');
      pp.querySelectorAll('[data-mt-kit-color]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!kitInput || b.disabled) return;
          pp.querySelectorAll('[data-mt-kit-color]').forEach(function (o) { o.classList.toggle('mt-activo', o === b); o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          kitInput.value = b.dataset.variante;
          var nombre = pp.querySelector('[data-mt-kit-nombre]');
          if (nombre) nombre.textContent = b.dataset.nombre;
          var img = pp.querySelector('.mt-pp__principal img');
          if (img && b.dataset.imagen) {
            var vid = pp.querySelector('.mt-pp__video');
            if (vid && !vid.hidden) { vid.pause(); vid.hidden = true; img.hidden = false; }
            img.src = b.dataset.imagen; img.removeAttribute('srcset');
            pp.querySelectorAll('.mt-pp__mini').forEach(function (m) { m.classList.toggle('mt-activo', m.dataset.src === b.dataset.imagen); });
          }
        });
      });

      // Calificación bajo el título: baja suavemente hasta la sección de opiniones
      var irOpiniones = pp.querySelector('[data-mt-ir-opiniones]');
      if (irOpiniones) {
        irOpiniones.addEventListener('click', function (ev) {
          var destino = document.getElementById(decodeURIComponent(irOpiniones.hash.slice(1)));
          if (!destino) return;
          ev.preventDefault();
          destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', irOpiniones.hash);
        });
      }

      // Fecha estimada de entrega contada desde hoy
      var entrega = pp.querySelector('[data-mt-entrega]');
      if (entrega && entrega.dataset.texto) {
        try {
          var fmt = new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'short' });
          var dia = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return fmt.format(d).replace('.', ''); };
          entrega.querySelector('span').textContent = entrega.dataset.texto
            .replace('{desde}', dia(parseInt(entrega.dataset.min, 10) || 8))
            .replace('{hasta}', dia(parseInt(entrega.dataset.max, 10) || 15));
        } catch (e) {}
      }

      // Barra fija de compra en móvil: aparece cuando el botón principal queda arriba, fuera de la pantalla
      var barra = pp.querySelector('[data-mt-barra]');
      var botonPrincipal = pp.querySelector('[data-mt-boton]');
      if (barra && botonPrincipal) {
        var botonBarra = barra.querySelector('[data-mt-barra-boton]');
        var pendiente = false;
        var revisarBarra = function () {
          pendiente = false;
          var mostrar = botonPrincipal.getBoundingClientRect().bottom < 0;
          if (mostrar === barra.classList.contains('mt-visible')) return;
          barra.classList.toggle('mt-visible', mostrar);
          barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
          botonBarra.tabIndex = mostrar ? 0 : -1;
        };
        window.addEventListener('scroll', function () {
          if (!pendiente) { pendiente = true; requestAnimationFrame(revisarBarra); }
        }, { passive: true });
        revisarBarra();
        botonBarra.addEventListener('click', function () {
          if (botonPrincipal.disabled) return;
          botonPrincipal.click();
        });
      }

      // CURP / RFC: mayúsculas, sin espacios y aviso claro si el formato no es válido
      var fiscal = pp.querySelector('[data-mt-fiscal]');
      if (fiscal) {
        fiscal.addEventListener('input', function () {
          var limpio = fiscal.value.toUpperCase().replace(/[^A-ZÑ&0-9]/g, '');
          if (limpio !== fiscal.value) fiscal.value = limpio;
          fiscal.classList.remove('mt-invalido');
          fiscal.setCustomValidity('');
        });
        fiscal.addEventListener('invalid', function () {
          fiscal.classList.add('mt-invalido');
          fiscal.setCustomValidity(fiscal.title);
        });
      }

      var datos = pp.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent || '[]');
      var input = pp.querySelector('input[name="id"]');
      var precio = pp.querySelector('[data-mt-precio]');
      var antes = pp.querySelector('[data-mt-precio-antes]');
      var boton = pp.querySelector('[data-mt-boton]');
      var formato = pp.dataset.mtFormato || '${{amount}}';
      function dinero(cent) {
        var v = (cent / 100).toFixed(2);
        var partes = v.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato.replace(/\{\{\s*amount\s*\}\}/, miles + '.' + partes[1])
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1]);
      }
      pp.querySelectorAll('.mt-pp__opcion input').forEach(function (r) {
        r.addEventListener('change', function () {
          var elegidas = [];
          pp.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            elegidas.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) { if (boton) { boton.disabled = true; boton.textContent = boton.dataset.noDisponible; } return; }
          if (input) input.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (antes) { if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = dinero(v.compare_at_price); antes.hidden = false; } else { antes.hidden = true; } }
          var vende = v.available && document.body.dataset.mtPausa !== 'true';
          if (boton) { boton.disabled = !vende; boton.textContent = vende ? boton.dataset.texto : boton.dataset.agotado; }
          // Cada color muestra su foto
          if (v.imagen) {
            var base = v.imagen.split('?')[0];
            var mini = Array.prototype.find.call(pp.querySelectorAll('.mt-pp__mini'), function (m) { return m.dataset.src.split('?')[0] === base; });
            if (mini) { mini.click(); } else if (principal) { principal.src = v.imagen; principal.removeAttribute('srcset'); }
          }
          try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
        });
      });
    });
  }

  /* Límite de piezas por pedido (el proveedor solo surte cierta cantidad por cliente) */
  var limite = parseInt(document.body && document.body.dataset.mtLimite, 10) || 0;
  var limiteAviso = (document.body && document.body.dataset.mtLimiteTexto) || '';
  var corrigiendo = false;

  // Excepciones por tipo de producto: «Mascarilla LED = 2 | aviso», una por línea
  var excepciones = {};
  ((document.body && document.body.dataset.mtLimiteExcepciones) || '').split(/\r?\n/).forEach(function (linea) {
    var m = linea.match(/^\s*([^=|]+?)\s*=\s*(\d+)\s*(?:\|\s*(.*))?$/);
    if (m) excepciones[m[1].trim().toLowerCase()] = { max: parseInt(m[2], 10), aviso: (m[3] || '').trim() };
  });
  function limiteDe(grupo) { var e = excepciones[grupo]; return e ? e.max : limite; }
  function avisoDe(grupo) { var e = excepciones[grupo]; return (e && e.aviso) || limiteAviso; }
  var hayLimite = limite > 0 || Object.keys(excepciones).length > 0;

  // El límite se cuenta por grupo: el tipo de producto (p. ej. los colores del masajeador cuentan juntos) o, si no tiene, el producto
  function grupoDe(item) {
    return (item.product_type || '').trim().toLowerCase() || String(item.product_id);
  }

  function totalGrupo(cart, grupo) {
    return cart.items.reduce(function (s, i) { return s + (grupoDe(i) === grupo ? i.quantity : 0); }, 0);
  }

  // Si el carrito trae más piezas de las permitidas en algún grupo, lo recorta y recarga la página
  function aplicarLimiteCarrito() {
    if (!hayLimite || corrigiendo) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      limitarSelectores(document, cart);
      var restantes = {}, updates = {}, sobra = false;
      cart.items.forEach(function (i) {
        var g = grupoDe(i);
        if (restantes[g] === undefined) restantes[g] = limiteDe(g) || Infinity;
        var q = Math.min(i.quantity, restantes[g]);
        if (q !== i.quantity) sobra = true;
        updates[i.key] = q;
        restantes[g] -= q;
      });
      if (!sobra) return;
      corrigiendo = true;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { window.location.reload(); });
    }).catch(function () {});
  }

  // Los botones de cantidad del carrito no dejan pasar del límite de su grupo (data-index = línea del carrito)
  var ultimoCarrito = null;
  function limitarSelectores(root, cart) {
    if (!hayLimite) return;
    if (cart) ultimoCarrito = cart;
    root.querySelectorAll('quantity-input input[name="updates[]"], quantity-input .quantity__input').forEach(function (inp) {
      var linea = ultimoCarrito && ultimoCarrito.items[(parseInt(inp.dataset.index, 10) || 0) - 1];
      var max = linea ? limiteDe(grupoDe(linea)) : limite;
      if (!max) { inp.removeAttribute('max'); return; }
      if (String(inp.max) === String(max)) return;
      inp.max = max;
      var qi = inp.closest('quantity-input');
      if (qi && qi.validateQtyRules) qi.validateQtyRules();
    });
  }

  function initLimite() {
    if (!hayLimite || window.__mtLimiteInit) return;
    window.__mtLimiteInit = true;
    aplicarLimiteCarrito();
    limitarSelectores(document);
    new MutationObserver(function () { limitarSelectores(document); }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, aplicarLimiteCarrito);

    // Página de producto: si ya hay una pieza en el carrito, avisa y lleva al carrito en vez de agregar otra
    document.querySelectorAll('[data-mt-producto] form[action*="/cart/add"]').forEach(function (form) {
      var seccion = form.closest('[data-mt-producto]');
      var grupo = (seccion.dataset.mtGrupo || '').trim().toLowerCase() || String(seccion.dataset.mtProductoId);
      form.addEventListener('submit', function (ev) {
        if (form.dataset.mtOk) return;
        ev.preventDefault();
        // Kit: agrega el masajeador del color elegido + los parches (las piezas reales) y lleva al carrito
        var kitMas = form.querySelector('[data-mt-kit-masajeador]');
        var kitPar = form.querySelector('[data-mt-kit-parche]');
        if (kitMas && kitPar) {
          var permalink = '/cart/' + kitMas.value + ':1,' + kitPar.value + ':1';
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var items = [];
            if (totalGrupo(cart, kitMas.dataset.grupo) < (limiteDe(kitMas.dataset.grupo) || Infinity)) items.push({ id: parseInt(kitMas.value, 10), quantity: 1 });
            if (totalGrupo(cart, kitPar.dataset.grupo) < (limiteDe(kitPar.dataset.grupo) || Infinity)) items.push({ id: parseInt(kitPar.value, 10), quantity: 1 });
            if (!items.length) { window.location.href = '/cart'; return; }
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
              .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/cart'; });
          }).catch(function () { window.location.href = permalink; });
          return;
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          // Piezas que se quieren agregar (selector de paquete: 1 o 2)
          var elegida = form.querySelector('input[name="quantity"]:checked') || form.querySelector('input[name="quantity"]');
          var cantidad = parseInt(elegida && elegida.value, 10) || 1;
          var max = limiteDe(grupo) || Infinity;
          if (totalGrupo(cart, grupo) + cantidad > max) {
            var aviso = form.querySelector('.mt-limite-aviso');
            if (!aviso) { aviso = document.createElement('p'); aviso.className = 'mt-limite-aviso'; form.appendChild(aviso); }
            aviso.innerHTML = avisoDe(grupo) + ' <a href="/cart">Ir al carrito →</a>';
            return;
          }
          // Complemento marcado («Completa tu ritual»): agrega las dos piezas juntas y lleva al carrito
          var extra = form.querySelector('[data-mt-complemento]:checked');
          if (extra) {
            var items = [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: 1 }];
            if (totalGrupo(cart, extra.dataset.grupo) < (limiteDe(extra.dataset.grupo) || Infinity)) items.push({ id: parseInt(extra.value, 10), quantity: 1 });
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
              .then(function () { window.location.href = '/cart'; });
          }
          // Extras elegidos (parches, o masajeador + parches): agrega la pieza principal y los extras juntos
          var ex = form.querySelector('[data-mt-extra]:checked');
          if (ex && ex.value) {
            var lista = [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: cantidad }];
            var ids = ex.value.split(','), grupos = (ex.dataset.grupos || '').split(',');
            ids.forEach(function (vid, k) {
              var g = (grupos[k] || '').trim();
              if (totalGrupo(cart, g) < (limiteDe(g) || Infinity)) lista.push({ id: parseInt(vid, 10), quantity: 1 });
            });
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lista }) })
              .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/cart'; })
              .catch(function () { window.location.href = '/cart'; });
          }
          form.dataset.mtOk = '1';
          form.submit();
        }).catch(function () { form.dataset.mtOk = '1'; form.submit(); });
      });
    });
  }

  /* Menú móvil: al tocar un enlace a una sección de la misma página (p. ej. /#opiniones), cerrar el menú */
  function initAnclasMenu() {
    if (window.__mtAnclasInit) return;
    window.__mtAnclasInit = true;
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('.menu-drawer a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash) return;
      var drawer = document.querySelector('header-drawer');
      if (drawer && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(ev);
      } else {
        var det = document.querySelector('.menu-drawer-container[open]');
        if (det) det.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
      }
      var destino = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (destino) setTimeout(function () { destino.scrollIntoView({ behavior: 'smooth' }); }, 50);
    });
  }

  /* Reseñas: botón «Ver más opiniones» */
  function initResenasMas(root) {
    root.querySelectorAll('[data-mt-res-mas]').forEach(function (b) {
      if (b.dataset.mtInit) return;
      b.dataset.mtInit = '1';
      b.addEventListener('click', function () {
        var muro = b.closest('section').querySelector('[data-mt-res-muro]');
        if (muro) muro.classList.add('mt-res--todas');
        b.parentNode.remove();
      });
    });
  }

  function initTodo(ev) {
    var root = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initRutina(root);
    initAntesDespues(root);
    initReveals(root);
    initTilt(root);
    initMagnetico(root);
    initHotspots(root);
    initFaq(root);
    initProducto(root);
    initResenasMas(root);
    initAnclasMenu();
    initCarrusel(root);
    initLimite();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();

/* Carrusel: escenas con dos colores (Negra / Blanca). El botón cambia precio y enlace de esa escena. */
document.addEventListener('click', function (ev) {
  var btn = ev.target.closest('[data-mt-hc-color-btn]');
  if (!btn) return;
  var grupo = btn.closest('[data-mt-hc-sync]');
  if (!grupo) return;
  var escena = grupo.getAttribute('data-mt-hc-sync');
  var i = btn.getAttribute('data-mt-hc-color-btn');
  grupo.querySelectorAll('[data-mt-hc-color-btn]').forEach(function (b) {
    var activo = b === btn;
    b.classList.toggle('mt-activo', activo);
    b.setAttribute('aria-pressed', activo ? 'true' : 'false');
  });
  document.querySelectorAll('[data-mt-hc-sync="' + escena + '"] [data-mt-hc-color], [data-mt-hc-sync="' + escena + '"][data-mt-hc-color]').forEach(function (el) {
    el.hidden = el.getAttribute('data-mt-hc-color') !== i;
  });
});

/* Extras: con el paquete de 2 el kit muestra su otro precio (el combo no se suma al descuento del paquete). */
document.addEventListener('change', function (ev) {
  if (!ev.target.matches('input[name="quantity"]')) return;
  var form = ev.target.form;
  if (!form) return;
  var dos = ev.target.value === '2';
  var p2 = form.querySelector('[data-mt-kit-precio="2"]');
  if (!p2) return;
  form.querySelector('[data-mt-kit-precio="1"]').hidden = dos;
  p2.hidden = !dos;
});


/* Pausa de ventas (ajuste global del tema): nadie agrega al carrito ni pasa al pago */
(function () {
  if (document.body.dataset.mtPausa !== 'true') return;
  var aviso = document.body.dataset.mtPausaAviso || 'Por ahora no estamos recibiendo pedidos.';
  // Ningún formulario puede agregar al carrito
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) { ev.preventDefault(); ev.stopImmediatePropagation(); }
    if (f && f.action && /\/cart(\?|$)/.test(f.action) && ev.submitter && ev.submitter.name === 'checkout') { ev.preventDefault(); ev.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (b) { ev.preventDefault(); ev.stopImmediatePropagation(); }
  }, true);
  // En el carrito: quita el botón de pago y deja el aviso
  function avisos() {
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (b.parentNode && !b.parentNode.querySelector('.mt-pausa-aviso')) {
        var p = document.createElement('p'); p.className = 'mt-pausa-aviso'; p.textContent = aviso; b.parentNode.insertBefore(p, b);
      }
    });
  }
  avisos();
  new MutationObserver(avisos).observe(document.body, { childList: true, subtree: true });
})();
